// Libraries
import styled from 'styled-components'
import { primary } from '../../assets/colorPallet'

export const StyledRadioGroupContainer = styled.div`
  .MuiRadio-colorPrimary.Mui-checked {
    color: ${primary};
  }
`
